import { IconProps } from './icons-props';

function PinIcon({ className, width = 22, height = 22 }: IconProps) {
    return (
        <svg
            fill='none'
            width={width}
            height={height}
            className={className}
            viewBox='0 0 20 20'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.27914 14.9169L1.42247 19.7561L0.244141 18.5777L5.10081 13.7369L6.27914 14.9169ZM11.5291 17.2211C12.2927 16.4544 12.8434 15.5021 13.1272 14.458C13.4109 13.4138 13.4179 12.3138 13.1475 11.2661L12.8875 10.2027L15.9041 7.16941L16.3791 7.64524C16.7299 8.00787 17.1971 8.23548 17.6988 8.2882C18.2006 8.34092 18.7048 8.21538 19.1233 7.93358C19.3701 7.75795 19.5756 7.53062 19.7256 7.26743C19.8755 7.00423 19.9663 6.71151 19.9915 6.40965C20.0167 6.10779 19.9758 5.80406 19.8717 5.51962C19.7675 5.23519 19.6025 4.9769 19.3883 4.76274L15.2866 0.65691C14.9356 0.294724 14.4685 0.0674134 13.9669 0.0147087C13.4653 -0.037996 12.9611 0.0872573 12.5425 0.368577C12.2955 0.544127 12.0897 0.771447 11.9396 1.03468C11.7895 1.29792 11.6986 1.59073 11.6733 1.8927C11.648 2.19467 11.6889 2.49853 11.7931 2.78308C11.8973 3.06763 12.0623 3.32603 12.2766 3.54024L12.8158 4.07858L9.79831 7.11191L8.74164 6.85274C7.69305 6.58103 6.59175 6.58731 5.54632 6.87095C4.50089 7.15459 3.54744 7.7058 2.77997 8.47024L2.48581 8.76524L11.2358 17.5152L11.5291 17.2211Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default PinIcon;

